import { render, staticRenderFns } from "./FilesDormant.vue?vue&type=template&id=8d3e6728"
import script from "./FilesDormant.vue?vue&type=script&lang=js"
export * from "./FilesDormant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports